export const CATCH_UP_FRIDAYS_PROMPT_NAME = 'catchUpFridays';